<!--
2023-06-15 YTW 转盘任务
-->
<template>
  <div class="lucky-wheel">
    <div class="topBar">
      <div class="record-btn" @click="record">
        {{ $t('lang.luckyWheel.record') }}
      </div>
      <div class="cancel-btn" @click="close">
        <img
          class="close-img"
          alt="fork"
          :src="cancelBtn"
        >
      </div>
    </div>
    <div class="wheel-content">
      <div class="wheelName"><b>{{ $t('lang.luckyWheel.name') }}</b></div>
      <div class="wheel">
        <div class="light"><img :src="playLuckyWheel" alt="light"/></div>
        <LuckyWheel
          :height="wheelSize"
          :width="wheelSize"
          ref="theWheel"
          :prizes="prizes"
          :blocks="blocks"
          :buttons="buttons"
          :defaultConfig="wheelConfig"
          @start="manualPlay"
        />
      </div>
      <div class="remainingTimes">
        <span>{{ $t('lang.luckyWheel.chances') }}&nbsp;&nbsp;{{ freeBetPlayTimes }}</span>
      </div>
      <div class="taskList">
        <div class="taskRow" v-for="(task,index) in toDoList" :key="'toDo'+index">
          <div class="name"><span>{{
              $t('lang.luckyWheel.taskName.' + task.TaskName)
            }}{{ '(' + task.DoneTaskValue + '/' + task.TaskValue + ')' }}</span>
            <div @click="openMeassge(index,task)" class="query" v-if="task.TaskName === 'upi_deposit_amount'">
              <div class="queryIcon">?</div>
              <div class="queryMask" v-show="toDoList[index].messageShow">
                <div class="triangle-up"></div>
                {{ $t('lang.luckyWheel.include') }}
                :{{task.PaymentGatewayNames}}
              </div>
            </div>

          </div>
          <div class="rightPart">
            <div class="times">{{ $t('lang.luckyWheel.chances') + '+' + task.CollectNum }}</div>
            <div class="btn" v-if="task.MayCollect" @click="getTimes(task)">{{ $t('lang.luckyWheel.claimBtn') }}</div>
            <div class="btn" v-else @click="goto(task)">{{ $t('lang.luckyWheel.executeBtn') }}</div>
          </div>
        </div>
        <div class="taskRow" v-for="(task,index) in doneList" :key="'done'+index">
          <div class="name"><span>{{
              $t('lang.luckyWheel.taskName.' + task.TaskName)
            }}{{ '(' + task.DoneTaskValue + '/' + task.TaskValue + ')' }}</span></div>
          <div class="rightPart">
            <div class="times">{{ $t('lang.luckyWheel.chances') + '+' + task.CollectNum }}</div>
            <div class="btn" style="filter: grayscale(100%)">{{ $t('lang.luckyWheel.claimedBtn') }}</div>
          </div>
        </div>
      </div>
    </div>
    <wheelConfirm :closeConfirm="closeConfirm"
                  :closeAll="closeAll"
                  :doingPlay="manualPlay"
                  :getTimes="getTimes"
                  :doTasks="doTasks"
                  :giftItem="giftItem"
                  :alertMsg="alertMsg"
                  :rewardMsg="rewardMsg"
                  :toDoList="toDoTips"
                  :confirmBtn="confirmBtn"
                  :freeBetPlayTimes="freeBetPlayTimes"
                  v-show="showConfirm"
    >
    </wheelConfirm>
    <wheelRecord
      :closeAll="closeAll"
      :closeRecord="closeRecord"
      :userInfo="userInfo"
      :wheelId="theOwnWheel"
      :showRecord="showRecord"
      v-show="showRecord"
    >
    </wheelRecord>
  </div>
</template>

<script>
import {LuckyWheel} from '@lucky-canvas/vue'
import {Carousel} from 'element-ui'
import request from '@/service'
import {Toast} from 'mint-ui'
import cancelBtn from '@/assets/images/wheel/vector.png'
import playLuckyWheel from '@/assets/images/wheel/playLuckyWheel.png'
import wheelConfirm from '@/components/Wheel/confirm'
import wheelRecord from '@/components/Wheel/record'
import {fetchBalance} from '@/utils'

export default {
  name: 'Wheel',
  props: ['handleClose', 'theOwnWheel'],
  components: {
    LuckyWheel,
    wheelConfirm,
    wheelRecord,
    Carousel
  },
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      toDoList: [],
      doneList: [],
      toDoTips: [],
      wheelSize: '0',
      isManualPlaying: false,
      autoPlayingInProgress: false,
      showConfirm: false,
      showRecord: false,
      alertMsg: [],
      rewardMsg: [],
      confirmBtn: 1, // 1、得到gift 2、等到冲赠券 4、没转盘次数，明日再来 5、没转盘次数，快去做任务  6、任务尚未完成 7、任务已经完成
      freeBetPlayTimes: 0,
      fetchBalance,
      playLuckyWheel,
      cancelBtn,
      blocks: [
        {
          padding: '5.65vw',
          imgs: [{
            src: require('../../assets/images/wheel/bk.png'),
            width: '100%',
            rotate: false
          }]
        }, {
          padding: '2.775vw',
          imgs: [{
            src: require('../../assets/images/wheel/bkCircle.png'),
            width: '100%',
            rotate: true
          }]
        }
      ],
      prizes: [
        {
          fonts: [{text: '', top: '11vw', fontColor: '#FFB84E', fontSize: '3.61vw', fontWeight: 600}],
          imgs: []
        },
        {
          fonts: [{text: '', top: '11vw', fontColor: '#FFFFFF', fontSize: '3.61vw', fontWeight: 600}],
          imgs: []
        },
        {
          fonts: [{text: '', top: '11vw', fontColor: '#FFB84E', fontSize: '3.61vw', fontWeight: 600}],
          imgs: []
        },
        {
          fonts: [{text: '', top: '11vw', fontColor: '#FFFFFF', fontSize: '3.61vw', fontWeight: 600}],
          imgs: []
        },
        {
          fonts: [{text: '', top: '11vw', fontColor: '#FFB84E', fontSize: '3.61vw', fontWeight: 600}],
          imgs: []
        },
        {
          fonts: [{text: '', top: '11vw', fontColor: '#FFFFFF', fontSize: '3.61vw', fontWeight: 600}],
          imgs: []
        },
        {
          fonts: [{text: '', top: '11vw', fontColor: '#FFB84E', fontSize: '3.61vw', fontWeight: 600}],
          imgs: []
        },
        {
          fonts: [{text: '', top: '11vw', fontColor: '#FFFFFF', fontSize: '3.61vw', fontWeight: 600}],
          imgs: []
        }
      ],
      buttons: [
        {
          radius: '25%',
          imgs: [{
            src: require('../../assets/images/wheel/Go.png'),
            width: '200%',
            top: '-200%',
            pointer: true,
            rotate: true
          }
          ]
        }
      ],
      giftItem: {},
      wheelConfig: {
        accelerationTime: 500,
        decelerationTime: 200,
        gutter: '2px'
      },
      top10WonMessages: []
    }
  },
  mounted () {
    this.getWheelInfo(this.theOwnWheel)
  },
  created () {
    const r = window.innerWidth * 0.7555
    this.wheelSize = r + 2
  },
  methods: {
    openMeassge (i, item) {
      item.messageShow = !item.messageShow
      this.$set(this.toDoList, i, item)
    },
    getWheelInfo (theOwnWheel) {
      let _this = this
      const url = 'innovation/luckywheel/get_wheel_info'
      let data = {}
      if (this.userInfo) {
        data = {WheelId: theOwnWheel, UserId: this.userInfo.UserId}
      } else {
        data = {WheelId: theOwnWheel}
      }
      request('post', url, data, true).then(res => {
        if (res) {
          if (res.Jackpot && res.Jackpot.length === 8) {
            let jackPot = res.Jackpot
            this.prizes.forEach((item, idx) => {
              item.id = jackPot[idx].PrizeId
              item.type = jackPot[idx].GiftType
              item.index = idx
              if (item.type === 'gift') {
                const coinSize = window.innerWidth * 0.0972
                item.imgs = [{
                  src: require('../../assets/images/wheel/coin.png'),
                  width: coinSize + 'px'
                }]
                item.fonts[0].text = _this.$t('lang.account.currencyType') + jackPot[idx].MaxGiftAmount
              } else {
                const cardSize = window.innerWidth * 0.1055
                item.imgs = [{
                  src: require('../../assets/images/wheel/card.png'),
                  width: cardSize + 'px'
                }]
                item.fonts[0].text = '+' + jackPot[idx].Discount + '%'
              }
            })
          }
          this.freeBetPlayTimes = res.UsableNum
          // {text: 'Sign in today(1/1)', type: 1, times: 1}
          this.toDoList = res.TodoTasks
          this.toDoList.forEach(item => {
            if (item.TaskName === 'upi_deposit_amount') {
              item.messageShow = false
            }
          })
          this.doneList = res.DoneTasks
        }
      })
    },
    close () {
      this.isManualPlaying = false
      this.handleClose()
    },
    record () {
      if (this.isManualPlaying) {
        return
      }
      this.showRecord = true
    },
    goToDeposit () {
      this.gotoRoute('Deposit')
    },
    gotoRoute (path) {
      this.$router.push('/' + path)
    },
    manualPlay: function () {
      if (this.showConfirm) {
        this.showConfirm = false
      }
      if (!this.userInfo) {
        this.closeAll()
        // this.$store.commit('setLoginPopShow', true)
        this.$router.push('/Login')
      }
      if (this.isManualPlaying) {
        return
      }
      if (this.freeBetPlayTimes <= 0) {
        this.alertMsg = this.$t('lang.luckyWheel.noTimes')
        this.toDoTips = this.toDoList
        if (this.toDoTips.length !== 0) {
          this.rewardMsg = this.$t('lang.luckyWheel.earnTimes')
          this.confirmBtn = 5
        } else {
          this.rewardMsg = this.$t('lang.luckyWheel.ComeBackTomorrow')
          this.confirmBtn = 4
        }
        this.showConfirm = true
        return
      }
      this.isManualPlaying = true
      this.freeBetPlayTimes = this.freeBetPlayTimes - 1
      this.$refs.theWheel.play()
      const url = `innovation/luckywheel/play_wheel`
      const data = {
        UserId: this.userInfo.UserId,
        WheelId: this.theOwnWheel
      }
      request('post', url, data, true).then(result => {
        setTimeout(() => {
          if (result && result.PrizeId && result.PrizeId !== -1) {
            let prize = this.prizes.filter(i => i.id === result.PrizeId)[0]
            this.giftItem = result
            this.$refs.theWheel.stop(prize.index)
            setTimeout(() => {
              this.alertMsg = [this.$t('lang.inviteFriends.congrats')]
              if (prize.type === 'gift') {
                this.rewardMsg = ['[' + prize.fonts[0].text + '] ' + this.$t('lang.luckyWheel.acquired')]
                this.confirmBtn = 2
                this.fetchBalance()
              } else {
                this.rewardMsg = ['[DEP' + prize.fonts[0].text + ']' + this.$t('lang.luckyWheel.acquired')]
                this.confirmBtn = 1
              }
              this.showConfirm = true
            }, 500)
          } else {
            this.$refs.theWheel.init()
            Toast(this.$t('lang.lottery.buyFailed'))
          }
        }, 2000)
        setTimeout(() => {
          this.isManualPlaying = false
        }, 3500)
      })
    },
    closeConfirm () {
      this.showConfirm = false
    },
    closeRecord () {
      this.showRecord = false
    },
    closeAll () {
      this.closeConfirm()
      this.closeRecord()
      this.close()
    },
    getTimes (item) {
      if (!this.userInfo) {
        // this.$store.commit('setLoginPopShow', true)
        this.$router.push('/Login')
        return
      }
      if (this.isManualPlaying) {
        return
      }
      const url = '/innovation/luckywheel/collect_num'
      let data = {UserId: this.userInfo.UserId, TaskId: item.TaskId, WheelId: this.theOwnWheel}
      request('post', url, data, true).then(res => {
        if (res) {
          this.doneList = res.DoneTasks
          this.toDoList = res.TodoTasks
          this.freeBetPlayTimes = res.UsableNum
          this.alertMsg = [this.$t('lang.inviteFriends.success')]
          this.rewardMsg = [this.$t('lang.luckyWheel.oneMoreTime') + item.CollectNum + '!']
          this.confirmBtn = 3
          this.showConfirm = true
        }
      })
    },
    doTasks (index) {
      if (this.isManualPlaying) {
        return
      }
      this.alertMsg = [this.$t('lang.inviteFriends.success')]
      this.toDoTips = [this.toDoList[index]]
      this.rewardMsg = this.$t('lang.luckyWheel.execute')
      this.confirmBtn = 6
      this.showConfirm = true
    },
    goto (task) {
      if (task.TaskName.toLowerCase().indexOf('deposit') > -1) {
        this.goToDeposit()
      } else if (task.TaskName.toLowerCase().indexOf('complete_user_information') > -1) {
        this.gotoRoute('Edit')
      } else {
        this.close()
      }
    },
    lookForOther () {
      if (this.isManualPlaying) {
        return
      }
      if (this.toDoList.length > 0) {
        this.alertMsg = [this.$t('lang.inviteFriends.success')]
        this.toDoTips = this.toDoList
        this.rewardMsg = this.$t('lang.luckyWheel.lookForOther')
        this.confirmBtn = 7
        this.showConfirm = true
      } else {
        this.alertMsg = [this.$t('lang.inviteFriends.sorry')]
        this.toDoTips = this.toDoList
        this.rewardMsg = this.$t('lang.luckyWheel.ComeBackTomorrow')
        this.confirmBtn = 4
        this.showConfirm = true
      }
    },
    covertTaskName (item) {
      let key = item.TaskName
      return this.$t('lang.luckyWheel.taskName')[key]
    }
  }
}
</script>
<style lang="less" scoped>
.lucky-wheel {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 200;
  padding: 5.556vw;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  background: #150606;

  .topBar {
    position: relative;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    width: 87vw;
    z-index: 9999999;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 8.4vw;

    .record-btn {
      width: max-content;
      font-family: Inter;
      font-size: 4.166vw;
      line-height: 4.166vw;
      font-weight: 500;
      height: calc(4.166vw + 3px);
      background-image: linear-gradient(96.92deg, #C2C2C2 -22.3%, #B5B5B5 48.3%, #7D7D7D 168.51%);
      -webkit-background-clip: text;
      color: transparent;
      border-bottom: 1.5px solid #ABABAB;
      margin-bottom: 1.5px;
    }

    .cancel-btn {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      z-index: 999;
      width: 15vw;
      height: 7.5vw;

      .close-img {
        width: auto;
        height: 3.055vw;
      }
    }

  }

  .wheel-content {
    .wheelName {
      margin-top: 3.5vw;
      text-align: center;
      font-family: Inter;
      font-size: 7.7778vw;
      font-style: italic;
      font-weight: 900;
      line-height: 9.444vw;
      letter-spacing: 0.05em;
      color: #FFFFFF;
      text-shadow: 0.5px 0.5px 0 #FFFFFF,
      -0.5px 0.5px 0 #FFFFFF,
        0.5px -0.5px 0 #FFFFFF,
        -0.5px -0.5px 0 #FFFFFF,
      0px 0.5px 0 #FFFFFF,
        0px -0.5px 0 #FFFFFF,
      -0.5px 0px 0 #FFFFFF,
      0.5px 0px 0 #FFFFFF;
    }

    .wheel {
      position: relative;
      top: 4vw;
      display: flex;
      justify-content: center;
      height: max-content;

      .light {
        position: absolute;
        top: -39vw;
        left: 50%;
        transform: translate(-50%);
        width: 150vw;
        z-index: -1;

        img {
          width: 100%;
        }
      }

    }

    .scrollHeight {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      height: 300px;
      max-width: 450px;
      padding-top: 30px;
      overflow: hidden;
    }

    .remainingTimes {
      color: #FFFFFF;
      height: 6.433vw;
      line-height: 6.433vw;
      width: max-content;
      font-family: Inter;
      font-size: 3.611vw;
      font-weight: 600;
      margin: 8.5vw auto 10vw auto;
      text-align: center;
      background: #CC323E;
      border-radius: 2.7vw;
      padding: 0 10vw;
    }

    .taskList {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      width: 86.667vw;
      height: max-content;
      background: #221919;
      border-radius: 2.223vw;
      max-height: 71.944vw;
      overflow-x: hidden;
      overflow-y: auto;

      .taskRow {
        height: 10.277vw;
        line-height: 10.277vw;
        width: 100%;
        border-bottom: 0.5vw solid #4E4E4E;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 2.777vw 0 4.444vw;
      }

      .taskRow:last-of-type {
        border: none;
      }

      .name {
        display: flex;
        align-items: center;
        font-family: Inter;
        font-size: 3.6111vw;
        font-weight: 500;
        height: 6.111vw;
        line-height: 3.6111vw;
        text-align: left;
        color: #FFFFFF;
        width: max-content;
        max-width: 41vw;
        .query {
          width: 8vw;
          height: 8vw;
          position: absolute;
          //border: 1px solid red;
          left: 40vw;
          display: flex;
          align-items: center;
          justify-content: center;

          .queryIcon {
            border-radius: 50vw;
            height: 5vw;
            width: 5vw;
            background: rgb(112, 112, 112);
            font-size: 3.6vw;
            color: #fff;
            text-align: center;
            line-height: 5vw;
            user-select: none;
          }
        }
        .queryMask {
          position: absolute;
          //height: 8vw;
          width: 22.8vw;
          //border: 1px solid red;
          //top: 17.6vw;
          left: -15.5vw;
          top: 8vw;
          z-index: 3;
          background: rgb(79,78,78);
          //background-size: cover; /* 背景图片大小自适应 */
          //background-position: center; /* 背景图片居中 */
          background-repeat: no-repeat; /* 背景图片不重复 */
          font-size: 2.5vw;
          color: #C3C3C3;
          //overflow: hidden;
          //white-space: pre-wrap;
          display: flex;
          padding: 1vw;
          word-wrap: break-word;
          word-break: break-all;
          letter-spacing: 0.1vw;
          border-radius: 1vw;
          .triangle-up {
            width: 0;
            height: 0;
            border-left: 1vw solid transparent;
            border-right: 1vw solid transparent;
            border-bottom: 1.9vw solid rgb(79,78,78);
            //background: red;
            position: absolute;
            left: 18.5vw;
            top: -1.5vw;
          }
        }
      }

      .rightPart {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 36vw;
        height: max-content;

        .times {
          font-family: Inter;
          font-size: 11px;
          font-weight: 500;
          line-height: 13.31px;
          text-align: right;
          color: #FFFFFF;
        }

        .btn {
          font-family: Inter;
          width: 16.944vw;
          height: 6.111vw;
          line-height: 6.111vw;
          text-align: center;
          background: #F1DAB0;
          color: #000000;
          font-size: 3.055vw;
          font-weight: 600;
          border-radius: 1.388vw;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Wheel/index.vue